/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerApiService } from './customer-api.service';
import { ConfigService } from 'src/app/service/config.service';

@Injectable({
  providedIn: 'root',
})
export class AnnotationApiService {
  private authpro: string;

  constructor(
    private api: CustomerApiService,
    private config: ConfigService,
  ) {
    this.authpro = this.config.appConfig.routing.authpro;
  }

  addNote(data: any): Observable<string> {
    return this.api.postText('/v3/chartanno/add', data);
  }

  delNote(item: { uid: string; entity: string }): Observable<string> {
    return this.api.getText('/v3/chartanno/delete', {
      project: this.authpro,
      uid: item.uid,
      entity: item.entity,
    });
  }
}
